import { request } from '../request';

/**
 * 查询自有招聘岗位的申请列表
 * GET /enterprise/job-postings/{id}/applications
 *
 * @param id 招聘 ID
 * @param params 分页参数 (page, page_size)
 */
export function fetchEnterpriseJobApplications(id: string, params?: Api.Resume.QueryApplicationsParams) {
  return request<Api.Resume.ApplicationPageResponse>({
    url: `/enterprise/job-postings/${id}/applications`,
    method: 'get',
    params
  });
}

/**
 * 审核自有招聘岗位的求职申请
 * POST /job-applications/{id}/review
 *
 * @param id 申请 ID
 * @param data 审核请求体数据 (accepted)
 */
export function reviewJobApplication(id: string, data: Api.Resume.ApplicationReviewRequest) {
  return request<Api.Resume.ApplicationResponse>({
    url: `/job-applications/${id}/review`,
    method: 'post',
    data
  });
}

/**
 * 撤回待处理的求职申请
 * POST /job-applications/{id}/withdraw
 *
 * @param id 申请 ID
 */
export function withdrawJobApplication(id: string) {
  return request<Api.Resume.ApplicationResponse>({
    url: `/job-applications/${id}/withdraw`,
    method: 'post'
  });
}

/**
 * 申请招聘岗位
 * POST /job-postings/{id}/applications
 *
 * submission_mode=PROVIDER_PROFILE 时提交当前供给方档案和已保存的求职草稿；
 * DIRECT_RESUME 时无需供给方档案，直接提交期望月薪和简历文件。不会将档案提交至供给方大厅审核。
 *
 * @param id 招聘 ID
 * @param data 申请请求体数据 (marketdto.ApplyJobRequest)
 */
export function applyJobPosting(id: string, data?: Api.Resume.ApplyJobRequest) {
  return request<Api.Resume.ApplicationResponse>({
    url: `/job-postings/${id}/applications`,
    method: 'post',
    data
  });
}

/**
 * 查询个人简历修订记录
 * GET /me/resumes
 *
 * @param params 筛选与分页参数 (status, page, page_size)
 */
export function fetchMyResumes(params?: Api.Resume.QueryResumesParams) {
  return request<Api.Resume.ResumePageResponse>({
    url: '/me/resumes',
    method: 'get',
    params
  });
}

/**
 * 创建个人简历
 * POST /me/resumes
 *
 * @param data 简历数据
 */
export function createResume(data: Api.Resume.ResumeRequest) {
  return request<Api.Resume.ResumeResponse>({
    url: '/me/resumes',
    method: 'post',
    data
  });
}

/**
 * 修订个人简历
 * PUT /me/resumes/{id}
 *
 * @param id 用于修订的现有简历 ID
 * @param data 简历数据
 */
export function updateResume(id: string, data: Api.Resume.ResumeRequest) {
  return request<Api.Resume.ResumeResponse>({
    url: `/me/resumes/${id}`,
    method: 'put',
    data
  });
}

/**
 * 查询我的求职申请列表
 * GET /my/job-applications
 *
 * @param params 分页参数 (page, page_size)
 */
export function fetchMyJobApplications(params?: Api.Resume.QueryApplicationsParams) {
  return request<Api.Resume.ApplicationPageResponse>({
    url: '/my/job-applications',
    method: 'get',
    params
  });
}

/**
 * 查询我的职位申请详情
 * GET /my/job-applications/{id}
 *
 * @param id 申请 ID
 */
export function fetchMyJobApplicationDetail(id: string) {
  return request<Api.Resume.ApplicationResponse>({
    url: `/my/job-applications/${id}`,
    method: 'get'
  });
}

/**
 * 获取求职附加资料草稿
 * GET /provider-profile/job-resume-draft
 */
export function fetchProviderJobResumeDraft() {
  return request<Api.Resume.ProviderJobResumeDraftResponse>({
    url: '/provider-profile/job-resume-draft',
    method: 'get'
  });
}

/**
 * 保存求职期望月薪和简历文件 (求职附加资料草稿)
 * PUT /provider-profile/job-resume-draft
 *
 * @param data 草稿保存数据 (marketdto.ProviderJobResumeDraftRequest)
 */
export function updateProviderJobResumeDraft(data: Api.Resume.ProviderJobResumeDraftRequest) {
  return request<Api.Resume.ProviderJobResumeDraftResponse>({
    url: '/provider-profile/job-resume-draft',
    method: 'put',
    data
  });
}

